import React from "react";

const Parent = React.lazy(() => import("../pages/home/parent/Parent"));
const Student = React.lazy(() => import("../pages/home/student/Student"));
const LearnerResults = React.lazy(() =>
  import("../pages/home/learner/LearnerResults"),
);

export const learnerRoutes = [
  {
    path: "/parent",
    element: <Parent />,
    title: "Parent Dashboard",
    description: "Follow your children's attendance, learning progress, and school payments.",
    allowedRoles: ["parent"],
  },
  {
    path: "/student",
    element: <Student />,
    title: "Student Dashboard",
    description: "Track your classes, attendance, results, and school updates.",
    allowedRoles: ["student"],
  },
  {
    path: "/results",
    element: <LearnerResults />,
    title: "Academic Results",
    description: "Review all subject results for the current academic session.",
    allowedRoles: ["parent", "student"],
  },
];
